import React from 'react'
import { MdBorderBottom } from 'react-icons/md'
import { ImageArea2,ImageArea, RoadContainer,LeftDiv, RoadWrapper,InfoRow } from './RoadMapElements'

import Fade from 'react-reveal/Fade';
import styled from 'styled-components';


const Hide = styled.div`

@media screen and (max-width: 768px){
    display: none;
}
`

const RoadMaps = () => {
    return (
        <RoadContainer id="services">
        <RoadWrapper>
        <div className="container justify-content-around" style={{}}>
        <div style={{textAlign: "center"}}>
        <p className="fw-bold " style={{fontSize: "4rem", color:"#fff" , lineHeight: " "}}>
               Ro<span style={{color:"#DA0000"}}>adma</span>p
           </p>
           </div>
          
         
 

            <div className="row offset-1">
            <Fade bottom>
                <div className="col-lg-4 col-md-6 col-sm-12 " style={{borderBottom: "1px solid #fff", borderRight: "1px solid #fff", borderLeft: "1px solid #fff" }}>
                <div className="mt-5 pt-5 mx-4" >
                    <h2 className="display-3 fw-bold" style={{color:"#da0000"}} > 20% SOLD </h2>
                    <p className="fs-5"> - 5 NFT giveaway between holders.</p>
                    <p className="fs-5"> - 5 ETH goes to the Community Chest</p>
                    <p className="fs-5"> - 5 ETH To marketing all the art work</p>   
                    </div>
                  </div>
                </Fade>
                
                <Fade top>
                <div className="col-lg-4 col-md-6 col-sm-12" style={{borderBottom: "1px solid #fff"}}>
                    <div className="mt-5 pt-5 mx-4" >
                    <h2 className="display-3 fw-bold" style={{color:"#da0000"}} > 40% SOLD </h2>
                    <p className="fs-5"> - Suggestions from the Community on Chest Utilities starts</p>
                    <p className="fs-5"> - 5 ETH goes to the Community <br/>  Chest</p>  
                    </div>
                </div>
                </Fade>
                <Fade bottom>
                <div className="col-lg-4 col-md-6 col-sm-12"  style={{borderRight: "1px solid #fff", borderLeft: "1px solid #fff" , borderBottom: "1px solid #fff"}}>
                
                <div className="mt-5 pt-5 mx-4" >
                    <h2 className="display-3 fw-bold" style={{color:"#da0000"}} > 60% SOLD </h2>
                    <p className="fs-5"> - Art Contest with 2.5ETH in prices Start (Check the Telegram Channel for more information)</p>
                    <p className="fs-5"> - 5 NFT giveaway between Holders.</p>  
                    <p className="fs-5"> - We are going to use 10 ETH to raise the floor price of all art work on OpenSea</p>  
                    </div>
                 </div>
                 </Fade>
                 <Fade top>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-5" style={{borderRight: "1px solid #fff" , borderBottom: "1px solid #fff",paddingBottom:'70px'}}>
                <div className="mt-5 pt-5 mx-4" >
                    <h2 className="display-3 fw-bold" style={{color:"#da0000"}} > 80% SOLD </h2>
                    <p className="fs-5"> - 5 ETH goes to the community Chest</p> 
                    <p className="fs-5"> - Polls for decide the best idea for the Community Chest util<br/>starts <br/></p>  
                    <p className="fs-5"> - 5 ETH goes to market holder’s artwork</p> 
                    </div>
               </div> 
               </Fade> 
               <Fade bottom>
                <div className="col-lg-5 col-md-6 col-sm-12 " style={{ }}>
                <div className="mt-5 pt-5 mx-4" >
                    <h2 className="display-3 fw-bold" style={{color:"#da0000"}}> 100% SOLD</h2>
                    <p className="fs-5"> - The Polls of the Community Chest Utility ends and put in to action</p>
                    <p className="fs-5"> - 40ETH are reserved for the Videogame Development Battle game for the limited-edition battle cards</p>  
                    <p className="fs-5"> - New 2nd edition Battle card NFTs starts</p>  
                    
                    </div>
                </div>
                </Fade>
               
         
            </div>
            
            
        </div>
        </RoadWrapper>
        </RoadContainer>
    )
}

export default RoadMaps
